import extend from 'lodash/extend';
import groupBy from 'lodash/groupBy';
import each from 'lodash/each';
import $ from 'jquery';
import moment from 'moment';
import Backbone from 'backbone';

import Route from './route.js';

import accountStore from 'zoomforth_zf/appglobals/account.js';
import analyticsDataFetcherStore from 'zoomforth_zf/appglobals/analytics-fetcher-cacher.js';



import { 
  DUMMY_EARLIEST_MOMENT,
  DUMMY_EARLIEST_UTC_MOMENT,
  floorMoment
} from 'zoomforth_primary_dashboard/lib/analytics.js';

const RouteCollection = Backbone.Collection.extend({
  model: Route,

  comparator: 'id',

  initialize: function(models, options) {

    options = options || {};
    if (!options.domains) {
      throw new Error('You must specify a `domains` collection');
    }
    this.domains = options.domains;

    this._loadedRouteDataOnce = $.Deferred();

    if (models && models.length) {
      this._loadedRouteDataOnce.resolve();
    }

    this.params = options.params || {};
  },

  url: function() {
    return '/api/routes?' +
      $.param(extend({}, this.params));
  },

  fetch: function() {
    var jqxhr = RouteCollection.__super__.fetch.apply(this, arguments);
    // Don't attempt to resolve this deferred more than once
    if (this._loadedRouteDataOnce.state() === 'pending') {
      jqxhr.done(this._loadedRouteDataOnce.resolve);
    }
    return jqxhr;
  },

  fetchAnalytics: function() {
    var analyticsDataFetcher = analyticsDataFetcherStore.get();

    // No raw `route.id exists` filter here: the custom filter processor only
    // supports eq/in operators (an 'exists' filter 500s), and it's redundant
    // anyway -- the route.id group_by already excludes documents without one.
    const gotVisitCounts = analyticsDataFetcher
      .request()
      .visits({ includeUnique: false })
      .group_by(['route.id'])
      .params({
        target_property: 'user.page_session_uuid',
        startDate: DUMMY_EARLIEST_MOMENT,
        endDate: floorMoment(moment())
      })
      .count_unique();

    var gotLastVisitTime = analyticsDataFetcher
      // getting the raw event timestamp because we
      // do not do any post-processing to get
      // the event timestamp. sometimes the event
      // timestamp does not exist and the UI then
      // renders the first unix date
      .params({ target_property: 'timestamp' })
      .maximum();

    $.when(gotVisitCounts, this._loadedRouteDataOnce)

      .done(({ data })=> {
        // this object looks like { 42: [{ route.id: 42, result: 4 }], 65:... }
        var resultByRouteId = groupBy(data, 'route.id');

        // Set every route visitCount to `0` or the returned result
        this.each((route)=> {

          var resultObj = resultByRouteId[route.id];
          if (resultObj) {
            route.set({ visitCount: resultObj[0].result });
          
          } else {
            route.set({ visitCount: 0 });
          }

        });

      });

    $.when(gotLastVisitTime, this._loadedRouteDataOnce)

      .done(({ data })=> {

        each(data, (r)=> {

          var route = this.get(r['route.id']);

          if (route) {
            route.set({ lastVisitTimestamp: moment(r.result) });
          }

        });

      });

    return $.when(gotVisitCounts, gotLastVisitTime).promise();

  }

}, {

  isValidNewRouteUrl(url) {

    var data = { route_url: url };

    var defer = $.Deferred();
    
    $.ajax({
      url: '/rpc/routes/check_new_url_validity',
      data: data,
      dataType: 'json',
      type: 'GET'
    
    }).done(function(response){
      
      if (response.error) {
        defer.reject(response.error);
      } else {
        defer.resolve();
      }

    });

    return defer.promise();
  },

  findValidNewRoutePath(baseUrl, basePath) {

    const deferUrlFound = $.Deferred();

    var increment = 0;    
    var potentialPath = (increment > 0) ? `${basePath}-${increment}` : basePath;

    // Check if the the page title leads to a valid new route for the domain,
    // otherwise append '-INCREMENT' to it and check again until a valid route
    // exists for this new page
    const findValidRoute = () => {
      // if we attempt to find a URL 3 times then return an empty string to get
      // things moving
      if (increment > 4) {
        deferUrlFound.reject();
      }

      potentialPath = (increment > 0) ? `${basePath}-${increment}` : basePath;

      return RouteCollection.isValidNewRouteUrl(`${baseUrl}/${potentialPath}`)
        .done(()=> { 
          deferUrlFound.resolve(potentialPath); 
        })
        .fail(()=> { 
          increment += 1; 
          findValidRoute(); 
        });
    };

    findValidRoute();

    return deferUrlFound.promise();
  }

});


export default RouteCollection;
